module.exports = [{"id":"CH","text":"Switzerland"},{"id":"DE","text":"Germany"},{"id":"AT","text":"Austria"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/Countries.json
// module id = 475
// module chunks = 4